import { createTheme } from "@material-ui/core/styles";
import {
    colorWhite,
    colorBlack,
    colorPrimary,
    colorSecondary,
    colorError,
    colorInputBorder,
    colorTextAdditional, colorSecondary_2, colorInputBorderGrayish, colorBorder,
} from "./constants/theme";
import {ThemeProvider} from "@material-ui/core/styles";
import React, {useEffect} from "react";
// @ts-ignore
import { LightenDarkenColor } from "lighten-darken-color";
// @ts-ignore
const ReduxThemeProvider = ({ children }) => {
    const theme = createTheme({
        palette: {
            common: {
                white: colorWhite,
                black: colorBlack,
            },
            primary: {
                main: colorPrimary,
            },
            secondary: {
                main: colorSecondary,
            },
            error: {
                main: colorError,
            },
            text: {
                primary: colorPrimary,
                secondary: colorInputBorder
            }
        },
        typography: {
            allVariants: {
                fontFamily: "DMSans",
                lineHeight: "26px",
                color: colorPrimary,
            },
            h2: {
                fontFamily: "Merriweather",
                fontSize: 28,
                fontWeight: "bold",
                lineHeight: "35px",
            },
            h3: {
                fontWeight: "bold",
                fontSize: 24,
                color: colorPrimary,
            },
            h4: {
                fontWeight: "bold",
                fontSize: 20,
                color: colorPrimary,
            },
            body2: {
                fontSize: 16,
                fontWeight: 700,
            },
            button: {
                fontWeight: "bold",
                fontSize: 16,
                textTransform: "none",
                color: colorPrimary,
            }
        },
        overrides: {
            MuiButton: {
                root: {
                    height: 48,
                    "&$disabled": {
                        backgroundColor: colorInputBorderGrayish + " !important",
                        border: "1.5px solid " + colorInputBorder,
                        borderRadius: "6px",
                    },
                },
                containedPrimary: {
                    color: colorPrimary,
                    backgroundColor: colorSecondary,
                    border: colorSecondary,
                    "&:hover": {
                        color: colorWhite,
                        backgroundColor: LightenDarkenColor(colorSecondary, -20),
                    },
                },
                containedSecondary: {
                    border: colorSecondary,
                    color: colorPrimary,
                    "&:hover": {
                        color: colorWhite,
                    },
                },
                contained: {
                    backgroundColor: colorWhite,
                    color: colorInputBorder,
                    border: "1.5px solid " + colorInputBorder,
                    borderRadius: "6px",
                    boxShadow: "none"
                }
            },
            MuiInput: {
                root: {
                    borderWidth: 1
                },
            },
            MuiIconButton: {
                root: {
                    padding: 0,
                },
            },
            MuiInputAdornment: {
                positionEnd: {
                    marginLeft: 8,
                },
            },
            MuiOutlinedInput: {
                root: {
                    "&$disabled": {
                        color: colorInputBorder,
                    },
                },
                notchedOutline: {
                    borderColor: colorInputBorder,
                },
                adornedEnd: {
                    display: "flex",
                    flexDirection: "row-reverse",
                    paddingLeft: "14px",
                    paddingRight: 0,
                },
            },
            MuiSelect: {
                root: {
                    width: 241,
                    height: 48
                }
            },
            MuiFormControlLabel: {
                label: {
                    "&$disabled": {
                        color: colorInputBorder,
                    }
                }
            }
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 765,
                lg: 1280,
                xl: 1920,
            },
        }
    });

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default ReduxThemeProvider;
